import { AlertBanner } from "@jti/core-components/components/AlertBanner";

import styles from "../BillingAddress.module.scss";

type BillingErrorMessageBoxProps = { children: React.ReactNode };

export const BillingErrorMessageBox = ({ children }: BillingErrorMessageBoxProps) => {
  return (
    <div className={styles.messageBox}>
      <AlertBanner tone="warning" data-testid="message-box" richDescription={children} />
    </div>
  );
};
